module.exports = __webpack_public_path__ + "img/28.aa0c4dfe.png";